import React from 'react'
import { Card } from 'antd'
import cl from 'classnames'
import { observer } from 'mobx-react'

import { Props } from './types'

import styles from './styles.module.scss'

const BasicCard: React.FC<Props> = (props) => {
	const { children, wrapperClassName, className, ...rest } = props
	return (
		<Card
			type="inner"
			className={cl(styles.cardWrapper, wrapperClassName, className)}
			{...rest}
		>
			{children}
		</Card>
	)
}

export default observer(BasicCard)
